import { render } from "./ChangingRoom.vue?vue&type=template&id=06ee58dc"
import script from "./ChangingRoom.vue?vue&type=script&lang=js"
export * from "./ChangingRoom.vue?vue&type=script&lang=js"

import "./ChangingRoom.vue?vue&type=style&index=0&id=06ee58dc&lang=scss"
script.render = render

export default script